import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Index from './component/Pages/Index';
import Contact from './component/Pages/Contact';
import About from './component/Pages/About';
import Product from './component/Pages/Product';
function App() {
  return (
    <Router>

      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="/product" element={<Product
 />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact
 />} />
        {/* Define your other routes similarly */}
      </Routes>
    </Router>
  );
}

export default App;
